module.exports = __webpack_public_path__ + "static/media/lc.78602fd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/lc.svg
// module id = 2364
// module chunks = 7